import { WaitlistForm } from '../components/WaitlistForm';

export function FinalCTA() {
  return (
    <section className="py-24 sm:py-32 text-center relative" id="waitlist">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-[radial-gradient(ellipse_at_center_top,rgba(255,107,26,0.08),transparent_60%)] pointer-events-none"
        aria-hidden="true"
      />

      <div className="max-w-[880px] mx-auto px-6 sm:px-8 relative">
        <h2 className="font-display font-extrabold text-ink-900 mb-6 text-[clamp(40px,7vw,88px)] leading-[0.95] tracking-[-0.045em]">
          Your <span className="text-saffron-500">handshake</span> deserves better.
        </h2>

        <p className="text-[17px] sm:text-[19px] text-ink-600 max-w-[60ch] mx-auto mb-3 leading-snug">
          Get your Mela ID in 90 seconds. Free forever. The first 1,000 verified businesses get{' '}
          <strong className="text-ink-900">founding-member status</strong>.
        </p>

        <FoundingProgramFootnote />

        <div className="mt-10 max-w-[480px] mx-auto text-left">
          <WaitlistForm source="marketing_site" />
        </div>
      </div>
    </section>
  );
}

// Red-team #9 — make the "founding 1000" promise operational, not marketing-speak.
function FoundingProgramFootnote() {
  return (
    <details className="text-[13px] text-ink-500 max-w-[60ch] mx-auto">
      <summary className="cursor-pointer underline decoration-dotted underline-offset-2 inline-block">
        What founding-member status means
      </summary>
      <ul className="mt-3 text-left space-y-1.5 list-disc list-inside marker:text-saffron-500 leading-snug">
        <li>50% off any paid tier, locked for life of the account.</li>
        <li>A distinct gold badge on your public profile (separate from the standard Mela-Verified gold).</li>
        <li>Direct WhatsApp line to the founding team for the first 12 months.</li>
        <li>Priority KYC queue — verified within 24 hours of submission.</li>
        <li>
          Status is granted to the first 1,000 accounts that complete PAN <em>and</em> GST
          verification. We will publicly close the program at 1,000 — no quiet extensions.
        </li>
      </ul>
    </details>
  );
}
